// test1067
(1067 && 0);
